import { SPACELIFT_VCS_REPO_SEARCH_COLUMN_ID } from "../constants";
import FileNameCell from "./FileNameCell";
import PathCell from "./PathCell";
import CommitCell from "./CommitCell";
import LastCommitCell from "./LastCommitCell";
import UpdatedAtCell from "./UpdatedAtCell";
import RowActionsCell from "./RowActionsCell";

export const SPACELIFT_VCS_REPO_SEARCH_CELLS = {
  [SPACELIFT_VCS_REPO_SEARCH_COLUMN_ID.FILE_NAME]: FileNameCell,
  [SPACELIFT_VCS_REPO_SEARCH_COLUMN_ID.PATH]: PathCell,
  [SPACELIFT_VCS_REPO_SEARCH_COLUMN_ID.COMMIT]: CommitCell,
  [SPACELIFT_VCS_REPO_SEARCH_COLUMN_ID.COMMIT_MESSAGE]: LastCommitCell,
  [SPACELIFT_VCS_REPO_SEARCH_COLUMN_ID.UPDATED_AT]: UpdatedAtCell,
  [SPACELIFT_VCS_REPO_SEARCH_COLUMN_ID.DROPDOWN]: RowActionsCell,
};
